import {Helmet} from '@dr.pogodin/react-helmet';

import {useGetPaymentTypeEnumQuery, useGetRoundingDefinitionListQuery} from '@dms/api/finance';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';

import {useNavigate} from 'shared/web';

import {DocumentRoundingDefinitionList} from './components/DocumentRoundingDefinitionList';

export function DocumentRoundingDefinitions() {
  const navigate = useNavigate();
  const {
    data: paymentTypes,
    isLoading: isPaymentTypesLoading,
    isError: isPaymentTypesError,
  } = useGetPaymentTypeEnumQuery();

  const {
    data: roundingDefinitions,
    isLoading: isRoundingDefinitionsLoading,
    isError: isRoundingDefinitionsError,
  } = useGetRoundingDefinitionListQuery({});

  const title = i18n.t('page.accounting.labels.documentRoundingDefinitions');

  const header: SettingsTemplateHeader = {
    title,
    actions: [
      {
        type: 'button',
        title: i18n.t('page.accounting.actions.addDefinition'),
        onClick: () => {
          navigate(settingsRoutes.documentRoundingDefinitionsAdd);
        },
        'data-testid': testIds.settings.documentRoundingDefinitionsEdit('createNew'),
      },
    ],
  };

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        header={header}
        isLoading={isPaymentTypesLoading || isRoundingDefinitionsLoading}
        isError={isRoundingDefinitionsError || isPaymentTypesError}
        data-testid="settings-document-rounding-definition-page"
      >
        <DocumentRoundingDefinitionList
          roundingDefinitions={roundingDefinitions}
          paymentTypes={paymentTypes}
        />
      </SettingsTemplate>
    </>
  );
}
